<template>

  <v-sidebar v-model:visible="display" position="left" :showCloseIcon="true"
             style="width: 21.5rem;"
           :baseZIndex="1000" :header="$t('apps')" class="layout-config p-0">
    <div class="layout-config-panel flex flex-column">
<!--      <div class="px-3">-->
<!--        &lt;!&ndash;        <h5>{{$t('settings')}}</h5>&ndash;&gt;-->
<!--        <div class="px-3">-->
<!--          <h5>{{$t('apps')}}</h5>-->
<!--        </div>-->
<!--      </div>-->


      <div class="layout-config-options p-3">
        <div class="p-datatable p-component p-datatable-responsive-scroll p-datatable-hoverable-rows"
             data-scrollselectors=".p-datatable-wrapper">
          <div class="p-datatable-wrapper">
            <table role="table" class="p-datatable-table">
              <tbody class="p-datatable-tbody" role="rowgroup">
              <tr tabindex="-1" role="row" class="" draggable="false" v-for="(item, i) of modifiedModel"
                  :key="item.label + i.toString()">
                <td @click="item.label !== 'to_do' ? openInNewPage(item.url) : openInNewPageToDo()" style="min-width: 14rem;" class="cursor-pointer flex align-content-center flex-nowrap card-container" role="cell">
                  <span v-if="item.image">
                    <img :src="item.image" style="height: 2.5rem">
                  </span>
                  <span v-else :class="['p-menuitem-icon', item.icon]"></span>
                  <span  class="flex align-items-center justify-content-center ml-2 p-menuitem-text">{{ $t(item.label) }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </v-sidebar>
</template>

<script>
import i18n from '@/locales/i18n'
import store from "@/store";
import vSidebar from "@/primevue/sidebar/Sidebar.vue";
import {mapGetters} from "vuex";
// import {useRoute} from "vue-router";
export default {
  name: "UserSettingsSidebar",
  data() {
    return {
      display: false,

      locale: i18n.vueI18n.global.locale.value,
      scale: parseInt(store.state.scale),
      d_layoutMode: this.layoutMode,
      scales: [12, 13, 14, 15, 16],
      locales: i18n.locales
    }
  },
  components:{vSidebar},

  computed: {
    ...mapGetters({
      checkPermission: 'checkPermission'
    }),
    modifiedModel() {
      // Base model array
      let model = [

        {
          label: 'planner',
          image: '/layout/images/smart/planner.png',
          url: 'https://tasks.office.com/amu.kz'
        },
        {
          label: 'to_do',
          image: '/layout/images/smart/objective.png',
          url: 'https://to-do.office.com/tasks?auth=2&auth_upn='+this.getEmail+'&utm_source=applauncher'
        },
        {
          label: 'calendar',
          image: '/layout/images/smart/calendar.png',
          url: 'https://outlook.office.com/calendar/view/month'
        },
        {
          label: 'outlook',
          image: '/layout/images/smart/outlook.png',
          url: 'https://outlook.office.com/mail/'
        },
      ];
      if (this.checkPermission(['salem'])) {
        console.log(this.checkPermission(['salem']))
        model.push({
          label: 'document',
          image: '/layout/images/smart/document.png',
          url: process.env.VUE_APP_API_BASE_URL + '/admin/go_to_salem?jwt_token=' + store.state.user.jwt_token
        });
      }
      if (this.checkPermission(['platonus'])) {
        model.push({
          label: 'platonus',
          image: '/layout/images/smart/platonus.png',
          url: process.env.VUE_APP_API_BASE_URL + '/admin/go_to_platonus?jwt_token=' + store.state.user.jwt_token
        });
      }
        model.push({
          label: 'moodle',
          image: '/layout/images/smart/moodle.png',
          url: 'https://lms.amu.kz/auth/oauth2/login.php?id=1&wantsurl=%2F&sesskey=AstanaMedUniver'
        });

        model.push({
          label: 'elibrary',
          image: '/layout/images/smart/elibrary.png',
          url: 'https://elib.amu.kz/ru/lib/?e_sort=&e_type_doc=books&e_language=&e_ds=&e_src=&e_author=&e_publishing_house=&e_title=&e_place_of_publication=&e_year=&e_keywords=&e_isbn='
        });
        model.push({
          label: 'situational_center',
          image: '/layout/images/smart/apm_emp.png',
          url: process.env.VUE_APP_API_BASE_URL + '/admin/dashboard?jwt_token=' + store.state.user.jwt_token
        });




      return model;
    },
    currentLocale() {
      return i18n.vueI18n.global.locale.value
    },
    getEmail() {
      return store.state.user.data.email
    }
  },
  watch: {
    display(to, from) {
      if (to !== from)
        this.locale = this.currentLocale
    },
  },
  mounted() {
    this.locale = this.currentLocale;
  },
  methods: {
    onLayoutModeChange() {
      // const layoutLink = document.getElementById('layout-css');
      // const layoutHref = 'layout/css/layout-' + menuColor + '.css';
      // this.replaceLink(layoutLink, layoutHref);
      //
      // const themeLink = document.getElementById('theme-css');
      // const urlTokens = themeLink.getAttribute('href').split('/');
      // urlTokens[urlTokens.length - 1] = 'theme-' + menuColor + '.css';
      // const newURL = urlTokens.join('/');
      //
      // this.replaceLink(themeLink, newURL, () => {
      //   this.$appState.isNewThemeLoaded = true;
      // });

    },
    changeLocale(value) {
      i18n.setLocale(value);
      this.$router.push({...this.$route, params: {...this.$route.params, locale: value}});
      this.display = false
    },
    decrementScale() {
      if (this.scales.includes(this.scale)) {
        this.scale--;
        this.applyScale();
        this.$toast.add({severity: 'success', summary: 'Font', detail: 'Font diminished', life: 3000});
      }
    },
    incrementScale() {
      if (this.scales.includes(this.scale)) {
        this.scale++;
        this.applyScale();
        this.$toast.add({severity: 'success', summary: 'Font', detail: 'Font increased', life: 3000});
      }
    },
    applyScale() {
      document.documentElement.style.fontSize = this.scale + 'px';
      store.commit('setScale', this.scale)
    },
    openInNewPage(url) {
      window.open(url, "_blank");
    },
    openInNewPageToDo() {
      window.open('https://to-do.office.com/tasks?auth=2&auth_upn='+this.getEmail+'&utm_source=applauncher', "_blank");
    },
    openModal() {
      this.display = true
    },
  }
}
</script>

<style scoped>

</style>
